import { useState, useCallback } from 'react'
import { gql, useMutation } from '@apollo/client'
import { ScheduleArticle, ScheduleArticleVariables } from '@apollo-types/ScheduleArticle'
import { useGraphQLErrorsHandler } from './useGraphQLErrorsHandler'
import { useArticleContext } from './useArticleContext'

type State = {
  schedulerStatus: 'idle' | 'pending' | 'succeeded' | 'failed'
}

const SCHEDULE_ARTICLE = gql`
  mutation ScheduleArticle($id: ID!, $scheduledAt: Date!) {
    scheduleArticle(id: $id, scheduledAt: $scheduledAt) {
      postID
    }
  }
`

export const useScheduler = (scheduledAt: Date, scheduleSucceeded: () => void) => {
  const {
    articleState: { id },
  } = useArticleContext()
  const [state, setState] = useState<State>({ schedulerStatus: 'idle' })
  const [scheduleMutation] = useMutation<ScheduleArticle, ScheduleArticleVariables>(
    SCHEDULE_ARTICLE,
  )
  const errorHandler = useGraphQLErrorsHandler()

  const schedule = useCallback(async () => {
    setState({ schedulerStatus: 'pending' })
    try {
      await scheduleMutation({ variables: { id, scheduledAt } })
      setState({ schedulerStatus: 'succeeded' })
      scheduleSucceeded()
    } catch (error) {
      setState({ schedulerStatus: 'failed' })
      errorHandler(error)
    }
  }, [scheduleMutation, id, scheduledAt, scheduleSucceeded, errorHandler])

  return { ...state, schedule }
}
